import { Link } from "react-router-dom";
import logo from "../../assets/logo.svg";
import { CONTACT_INFO, NAV_LINKS, SERVICE_CONTENT } from "../utils/constants";
import MarketTicker from "./MarketTicker";
import AmbientBackground from "./AmbientBackground";

const Footer = () => {
    return (
        <footer className="footer">
            <AmbientBackground />
            <div className="footer-content">
                <div className="footer-brand-block">
                    <img className="footer-logo" src={logo} alt={CONTACT_INFO.businessName} />
                    <p>Personal, full-service financial guidance for working professionals—managed with clarity, care and a complete view of your finances.</p>
                </div>

                <nav className="footer-column" aria-label="Footer navigation">
                    <h4>Explore</h4>
                    {NAV_LINKS.map((link) => (
                        <Link to={link.path} key={link.path}>{link.label}</Link>
                    ))}
                </nav>

                <div className="footer-column footer-services-list">
                    <h4>Expertise</h4>
                    {SERVICE_CONTENT.map((service) => (
                        <span key={service.title}>{service.title}</span>
                    ))}
                </div>

                <div className="footer-conversation">
                    <h4>Contact</h4>
                    <a className="footer-phone" href={CONTACT_INFO.callLink}>{CONTACT_INFO.phoneDisplay}</a>
                    <a className="footer-email" href={CONTACT_INFO.mailLink}>{CONTACT_INFO.email}</a>
                    <p className="footer-address">
                        {CONTACT_INFO.addressLines.map((line) => (
                            <span key={line}>{line}</span>
                        ))}
                    </p>
                    <Link to="/contact" className="footer-contact-link">Book a consultation <span aria-hidden="true">↗</span></Link>
                </div>
            </div>

            <MarketTicker variant="footer" />

            <div className="footer-legal">
                <span>&copy; {new Date().getFullYear()} {CONTACT_INFO.businessName}</span>
                <div className="footer-policy-links">
                    <Link to="/disclaimer">Disclaimer</Link>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                </div>
                <a className="footer-powered-by" href="https://www.thewhizkind.com" target="_blank" rel="noopener noreferrer">&lt;powered by thewhizkind&gt;</a>
                <span>Vaishali, Ghaziabad · Serving clients across India</span>
            </div>
        </footer>
    );
};

export default Footer;
